import React from "react";
import { AlertTriangle, X, Trash2 } from "lucide-react";

export function DeleteConfirmModal({ isOpen, onClose, onConfirm, title, message }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop blur */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-in fade-in zoom-in-95 duration-200 border border-slate-100">
        
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute right-4 top-4 p-1.5 rounded-lg hover:bg-slate-50 text-slate-400 hover:text-slate-600 transition-colors"
          title="Close Dialog"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Content */}
        <div className="p-6 text-center">
          {/* Danger Warning Icon Circle */}
          <div className="w-12 h-12 rounded-full bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-4 border border-red-100">
            <AlertTriangle className="w-5 h-5 animate-pulse" />
          </div>

          <h3 className="text-[15px] font-bold text-slate-800">{title || "Confirm Delete"}</h3>
          <p className="text-[12px] text-slate-500 mt-2 leading-relaxed">
            {message || "Are you sure you want to delete this record? This action cannot be undone."}
          </p>
        </div>

        {/* Action Footer */}
        <div className="px-6 py-4 bg-slate-50/50 border-t border-slate-100 flex items-center justify-end gap-3">
          <button 
            onClick={onClose} 
            className="btn-secondary py-2 text-[12px] font-semibold text-slate-600"
          >
            Cancel
          </button>
          <button 
            onClick={() => {
              onConfirm();
              onClose();
            }} 
            className="btn-primary py-2 px-4 text-[12px] font-semibold bg-red-600 hover:bg-red-700 text-white flex items-center gap-1.5 border-none shadow-sm transition-all hover:scale-[1.01]"
          >
            <Trash2 className="w-3.5 h-3.5" />
            Delete
          </button>
        </div>

      </div>
    </div>
  );
}
